import { createContext, useContext } from "react"

export interface AuthState {
	authToken: string
}

export interface RefreshTokenResponse extends AuthState {
	refreshLogin: string
}

export enum AuthStateStatusEnum {
	AUTHENTICATING = "AUTHENTICATING",
	LOGGED_IN = "LOGGED_IN",
	LOGGED_OUT = "LOGGED_OUT",
}

export interface AuthContextType {
	status: AuthStateStatusEnum
	logOut: () => Promise<void>
	isLoggedIn: () => boolean
}

export const initialAuthState = AuthStateStatusEnum.LOGGED_OUT

export const AuthContext = createContext<AuthContextType>(null!)

export const useAuth = () => useContext(AuthContext)
